import { z } from "zod";

import { defineContractFromMeta } from "@shared/functions.ts";

const CONTRACT_NAME = "start-specification-run";

const StartSpecificationRunInputSchema = z.object({
  specificationId: z.string().uuid(),
});
export type StartSpecificationRunInput = z.input<
  typeof StartSpecificationRunInputSchema
>;

const StartSpecificationRunOutputSchema = z.object({
  ok: z.literal(true),
  pgflowRunId: z.string().uuid(),
});
export type StartSpecificationRunOutput = z.output<
  typeof StartSpecificationRunOutputSchema
>;

const StartSpecificationRunContract = defineContractFromMeta({
  name: CONTRACT_NAME,
  meta: import.meta,
  input: StartSpecificationRunInputSchema,
  output: StartSpecificationRunOutputSchema,
});

export default StartSpecificationRunContract;
export type StartSpecificationRunContract = typeof StartSpecificationRunContract;
